import { GlobalStyles } from "@mui/material";
import { cssVariables } from "./tokens";

export const ThemeCssVariables = () => <GlobalStyles styles={{ ":root": cssVariables }} />;